import {BaseModel} from '../../_base/crud';

export class LeaderLevelModel extends BaseModel {
    id: number;
    name: string;
    minResellers: number;
    maxResellers: number;
    minCampaigns: number;
    minInvoiceAmount: number;
    active: boolean;

    clear() {
        this.name = '';
        this.minResellers = null;
        this.maxResellers = null;
        this.minCampaigns = null;
        this.minInvoiceAmount = null;
    }
}
